const RESET_ERROR = 'classpass/error/RESET';

export const resetError = () => ({ type: RESET_ERROR });

export default function reducer(state = null, action = {}) {
  const { type, error } = action;

  if (type === RESET_ERROR) {
    return null;
  }
  if (error && type.indexOf('@@redux-form') === -1) {
    if (!action.suppressGlobalErrorHandling) {
      return {
        message: typeof error === 'string' ? error : error.message,
        details: error && error.details,
        code: error && error.code,
        httpStatus: error && error.httpStatus,
        sagaStack: error && error.sagaStack,
      };
    }
  }

  return state;
}
